import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.notification-types';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsNotificationTypesEffects {

    NotificationTypes$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_NOTIFICATION_TYPES),
        mergeMap((x: ac.GetNotificationTypesAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getNotificationTypes().pipe(
                map((result: any) => {
                    return new ac.GetNotificationTypesErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetNotificationTypesFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsTemplatesService);
        }
        return this.service;
    }
}
